/** @jsx jsx */

/** @jsxFrag React.Fragment */
import { jsx } from '@emotion/react';

import * as React from 'react';

// FIXME: existing import/no-cycle violations are excused to prevent seeing errors when modifying other parts of the same file; please fix it carefully
// eslint-disable-next-line import/no-cycle
import {
  ClipRecommendations,
  RecommendedActions,
  RecommendedNavigation,
} from 'bundles/ai-course-coach/components/Conversation/components/Messages';
import type {
  AiCoachNavigationButtonsFragment,
  AiCoachNavigationButtons_AiCoach_GoToFirstItemNavigationButton_Fragment as GoToFirstItemNavigationButton,
} from 'bundles/ai-course-coach/queries/__generated__/aiCoachNavigationButtonsFragment';
import type { CustomCompMessage, Link, MessageTypes } from 'bundles/ai-course-coach/store/types';
import type { SendMessageFunc } from 'bundles/ai-course-coach/utils/types';

import _t from 'i18n!nls/learning-assistant-chat-ai';

const navigationButtonIsGoToFirstItem = (
  navigationButton: AiCoachNavigationButtonsFragment
): navigationButton is GoToFirstItemNavigationButton => {
  return navigationButton.__typename === 'AiCoach_GoToFirstItemNavigationButton';
};

type Props = {
  message: MessageTypes | Link | CustomCompMessage;
  sendMessage: SendMessageFunc;
  courseId?: string | undefined;
  showRecommendedActions: boolean;
};

export const CoachRecommendations = (props: Props): React.ReactElement | null => {
  const {
    message: { timestamp, clipRecommendations, recommendedActions, navigationButtons },
    sendMessage,
    courseId,
    showRecommendedActions,
  } = props;

  return (
    <>
      {navigationButtons?.length ? (
        <div role="region" aria-label={_t('Recommended navigation')}>
          <RecommendedNavigation navigationButton={navigationButtons.filter(navigationButtonIsGoToFirstItem)[0]} />
        </div>
      ) : null}
      {clipRecommendations?.length ? (
        <div role="region" aria-label={_t('Recommended clips')}>
          <ClipRecommendations
            clips={clipRecommendations}
            trackingName="ai_course_coach_clips_recommendation"
            courseId={courseId}
          />
        </div>
      ) : null}
      {recommendedActions?.length && showRecommendedActions ? (
        <div role="region" aria-label={_t('Recommended actions')}>
          <RecommendedActions recommendedActions={recommendedActions} sendMessage={sendMessage} timestamp={timestamp} />
        </div>
      ) : null}
    </>
  );
};

export default CoachRecommendations;
